/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

export default function Plus({ fill }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 16 17"
		>
			<path
				fill={fill}
				d="M8 1.02a1.5 1.5 0 0 1 1.5 1.5v4.492h4.52a1.5 1.5 0 0 1 0 3H9.5V14.5a1.5 1.5 0 1 1-3 0v-4.489H2.003a1.5 1.5 0 0 1 0-3H6.5L6.5 2.52A1.5 1.5 0 0 1 8 1.02Z"
			/>
		</svg>
	);
}

Plus.propTypes = {
	fill: PropTypes.string,
};

Plus.defaultProps = {
	fill: '#146FB4',
};
